import { InputSize } from 'src/components/primitives/Input/types';

export const STANDARD_INPUT_HORIZONTAL_PADDING_CLASSNAME: Record<
	InputSize,
	string
> = {
	xs: 'px-sm',
	sm: 'px-md',
	md: 'px-md',
};

export const STANDARD_INPUT_VERTICAL_PADDING_CLASSNAME: Record<
	InputSize,
	string
> = {
	xs: 'py-sm',
	sm: 'py-sm',
	md: 'py-md',
};

export const STANDARD_INPUT_TEXT_SIZE_CLASSNAME: Record<InputSize, string> = {
	xs: 'typo-t4',
	sm: 'typo-t3',
	md: 'typo-t3',
};
